import React from 'react';
import { useBreakpoint } from 'utils/useBreakpoint';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg';

interface ResponsiveWrapperProps {
  desktopComponent: React.ReactNode;
  mobileComponent: React.ReactNode;
  breakpoint?: Breakpoint;
}

export const ResponsiveWrapper: React.FC<ResponsiveWrapperProps> = ({
  desktopComponent,
  mobileComponent,
  breakpoint = 'lg',
}) => {
  const breakpointInfo = useBreakpoint();

  const map: Record<Breakpoint, keyof typeof breakpointInfo> = {
    xs: 'isXsUp',
    sm: 'isSmUp',
    md: 'isMdUp',
    lg: 'isLgUp',
  };

  const key = map[breakpoint];
  const shouldShowDesktop = breakpointInfo[key];

  return shouldShowDesktop ? <>{desktopComponent}</> : <>{mobileComponent}</>;
};
